
import HRMatchModel from './hr-match-model';
/**
 * Model for Category/Tournaments
 */
export default class HRTournamentModel {
  /**
   * class constructor method
   * @param data
   */
  constructor(data) {
    /**
     * Category id
     * @type {number}
     */
    this.categoryId = data.cid;
    /**
     * Tournament id
     * @type {number}
     */
    this.id = data.id;
    /**
     * Category name
     * @type {string}
     */
    this.categoryName = data.nc;
    /**
     * Category css
     * @type {string}
     */
    this.categoryCss = data.ccss;
    /**
     * Tournament name
     * @type {string}
     */
    this.tournamentName = data.nt;
    /**
     * Horse races
     * @type {HRMatchModel[]}
     */
    this.horseRaces = data.ohr.map(t => new HRMatchModel(t));
    /**
     * IsGroup flag
     * @type {boolean}
     */
    this.isGroup = data.gItem;
    /**
     * Sport id - taken from parent id
     * @type {number}
     */
    this.sportId = data.sid;
  }
}
